import React from 'react';

// interface MessageProps {
//     message: string;
// }

function ErrorComponent(){
    return (
        <>
            <h1>Welcome to error component</h1>
        </>
    );
};

export default ErrorComponent;